import './Styles/styles.css';
import 'antd/dist/reset.css';

import { Route, Routes } from 'react-router-dom';

import Layout from './Layout';
import { useAuth } from './AuthContext';
import MainTable from './Pages/MainTable';
import AddProject from './Pages/AddProject';
import { NotFound } from './Pages/error/NotFound';
import CreateNewVersion from './Pages/CreateNewVersion';
import AutoRenderDashboard from './Pages/AutoRenderDashboard/AutoRenderDashboard';
import TaxDashboard from './Pages/TaxCalculation/TaxCalculation';
import UserManagement from './Pages/UserManagement/UserManagement';
import ProjectTable from './Pages/projects/ProjectTable';

const App = () => {
  const { user } = useAuth();

  return (
    // key  forces remount when accountId changes
    <div key={user.accountId}>
      <Routes>
        <Route path='/' element={<Layout />}>
          <Route path='*' element={<NotFound />} />
          <Route index element={<MainTable />} />
          <Route path='v2' element={<ProjectTable />} />
          <Route path='add-project' element={<AddProject />} />
          <Route path='auto-render' element={<AutoRenderDashboard />} />
          <Route path='tax' element={<TaxDashboard />} />
          <Route path='new-version/:parentProjectId' element={<CreateNewVersion />} />
          <Route path='admin/users' element={<UserManagement />} />
        </Route>
      </Routes>
    </div>
  );
};

export default App;
